// extracted by mini-css-extract-plugin
module.exports = {"inlineFieldLayout":"email-input-group__inlineFieldLayout___3uGFV","infoTextOverflow":"email-input-group__infoTextOverflow___3KHMm"};